import pubsub from '@viewlift/pubsub';
import React from 'react';
import { useNavigate } from 'react-router-dom';
function Item(_a) {
    var _b;
    var slide = _a.slide;
    var placeholder = window === null || window === void 0 ? void 0 : window.app_data.appcmsMain.images.placeholderCover;
    var navigate = useNavigate();
    function getStyles() {
        return { background: 'lightgray' };
    }
    var getBackgroundColor = function () {
        var _a, _b, _c, _d;
        var bgColor = (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.backgroundColor;
        return { backgroundColor: bgColor };
    };
    return (React.createElement("div", { className: 'thumnail-item', onClick: function () {
            pubsub.publish('apploading', true);
            if (slide === null || slide === void 0 ? void 0 : slide.newTab) {
                window.open(slide.url);
            }
            else {
                navigate(slide === null || slide === void 0 ? void 0 : slide.url);
            }
        } },
        React.createElement("img", { className: "thumnail-item-image", alt: "", src: ((_b = slide === null || slide === void 0 ? void 0 : slide.imageGist) === null || _b === void 0 ? void 0 : _b.r16x9) || placeholder, style: getStyles() }),
        React.createElement("div", { className: 'thumnail-item-info', style: getBackgroundColor() }, slide.title)));
}
export default Item;
